import * as z from "zod";

export const creditSchema = z.object({
  companyId: z.number().int().nonnegative(),
  creditLimit: z.number().nonnegative({ message: "validation:creditLimitNegative" }),
  remainingCredit: z.number().nonnegative({ message: "validation:remainingCreditNegative" }),
});

export const CreditValidationSchema = creditSchema;
export type CreditFormInput = z.infer<typeof CreditValidationSchema>;
